<template>
  <div class="text-center">
    You will be automatically redirected.
    Or <router-link :to="redirectPath">click here</router-link>.
  </div>
</template>

<script>
export default {
  name: 'redirect',
  props: ['redirectPath'],
  methods: {
    redirect() {
      setTimeout(() => this.$router.push({ path: this.redirectPath }), 7000)
    },
  },
  mounted() {
    this.redirect()
  },
}
</script>
